import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { timeFromNow } from 'helpers/date'
import { _isInteractionMode } from 'store/selectors/Room'

import { MOOD, FOOD_FIGHT_DURATION, WAVE_HAND_PERIOD } from '../../constants'

const useShowInteraction = uuid => {
    const [showInteraction, setShowInteraction] = useState(false)
    const [shouldWave, setShouldWave] = useState(false)
    const localMood = useSelector(_isInteractionMode)
    const userMood = useSelector(state => {
        const moods = state?.websocket?.roomStateMsg?.participants_mood
        if (moods) {
            return moods.find(mood => mood.user === uuid)
        }
    })

    const handleGreetingMood = userMood => {
        if (!userMood) return

        let canFight = false
        const isUserMoodFun = userMood?.mood === MOOD.FUN
        const _timeFromNow = timeFromNow(userMood?.joined_at)

        // user should be able to wave hand if
        // the diff between current time & user's joining time is within WAVE_HAND_PERIOD
        const _shouldWave = isUserMoodFun && _timeFromNow < WAVE_HAND_PERIOD

        if (localMood === MOOD.FUN) {
            canFight = _timeFromNow < FOOD_FIGHT_DURATION
        }

        setShouldWave(() => _shouldWave)
        setShowInteraction(() => canFight)
    }

    useEffect(() => {
        handleGreetingMood(userMood)
    }, [userMood])

    const resetMood = () => setShowInteraction(() => false)

    return {
        isFunMood: userMood?.mood === MOOD.FUN,
        resetMood,
        shouldWave,
        setShouldWave,
        showInteraction,
    }
}

export default useShowInteraction
